import React from 'react';

interface IProps {
  required: boolean;
}

const UploadButton: React.SFC<IProps> = (props: IProps) => (
  <button className={`upload-button ${props.required ? '' : 'optional'}`}>Upload</button>
);

export default UploadButton;
